// extracted by mini-css-extract-plugin
module.exports = {"banner":"Press_banner__2hH6s","btn":"Press_btn__2kj1a","itemsOnImg":"Press_itemsOnImg__80-Wr"};